import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AreaTemporariaService } from '@services/area-temporaria.service';

@Component({
	selector: 'seira-area-temporaria',
	templateUrl: './area-temporaria.component.html',
	styleUrls: ['./area-temporaria.component.scss'],
})
export class AreaTemporariaComponent implements OnInit {
	@ViewChild('container', { read: ViewContainerRef })
	container?: ViewContainerRef;

	constructor(private areaTemporariaService: AreaTemporariaService) {}

	ngOnInit(): void {
		this.areaTemporariaService.component.subscribe(res => {
			this.container!.clear();
			if (!res.componente) {
				return;
			}
			const componentRef = this.container!.createComponent<any>(res.componente);
			Object.keys(res.input!).forEach(key => {
				componentRef.instance[key] = res.input![key];
			});
			if (res.callbackReferencia) {
				res.callbackReferencia(componentRef);
			}
		});
	}
}
